import {
    TREEVIEWDESIGNER_DELETE_BUSINESSPROCESS
} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';

import {
    DeleteTreeViewParameters,
    DeleteTreeViewResult
} from '~/shared/src/utilities/modules/treeDesigner';
import {clearElusiveData} from '~/frontend/src/actions/elusiveData';
import xhr from '~/frontend/src/utilities/xhr';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {number} businessProcessId
 * @param {( responseData : DeleteTreeViewResult ) => void} [successCallback]
 *
 * @return {Promise<DeleteTreeViewResult | false>}
 */
const deleteBusinessProcess = ( panelKey : string, businessProcessId : number, successCallback? : ( responseData : DeleteTreeViewResult ) => void ) : Thunk<Promise<DeleteTreeViewResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<DeleteTreeViewResult | false> => {
    dispatch( {
        type: TREEVIEWDESIGNER_DELETE_BUSINESSPROCESS,
        panelKey,
        businessProcessId
    } );

    let retVal : DeleteTreeViewResult | false = false;

    dispatch( clearElusiveData( panelKey ) );

    const params : DeleteTreeViewParameters = {
              viewId: businessProcessId
          },
          response                          = await xhr.post(
              `${BASE_URL}/api/treeDesigner/deleteTreeView`,
              params,
              undefined,
              panelKey,
              'deleteTreeView',
              dispatch
          );

    if ( response?.data.success && !response.data.errorTitle ) {
        if ( successCallback ) {
            successCallback( response.data as DeleteTreeViewResult );
        }

        retVal = response.data as DeleteTreeViewResult;
    }

    return retVal;
};
export type DeleteBusinessProcess = typeof deleteBusinessProcess;

export default deleteBusinessProcess;
